<template>
  <div class="patient-info">
    <van-overlay
      class="loading-center"
      :show="loading"
      @click="show = false"
    >
      <van-loading size="50">加载中...</van-loading>
    </van-overlay>
    <template v-if="!showEdit">
      <van-cell-group inset style="margin-top:10px">
        <van-cell title="关系" :value="data.defaultStatus ? '本人' : '他人'" />
        <van-cell title="姓名" :value="data.patientName" />
        <van-cell title="证件类型" :value="data.documentName" />
        <van-cell title="证件号" :value="data.patientSfzh" />
        <van-cell title="手机号" :value="data.patientPhone" />
        <van-cell title="住址" :value="data.address" />
      </van-cell-group>
      <template v-if="data.id">
        <div style="margin-top:55%">
          <van-button round class="patient-info-btn" type="info" @click="editBtn">编辑</van-button>
          <van-button round class="patient-info-btn" :disabled="data.defaultStatus*1 === 1" :loading="setLoading" @click="setdefault">设置默认就诊人</van-button>
          <van-button round class="patient-info-btn" :loading="unLoading" @click="unbind">解除绑定</van-button>
        </div>
      </template>
    </template>
    <template v-else>
      <editPatient :info="data" @editSuccess="editChange" />
    </template>
  </div>
</template>
<script>
import editPatient from '../addPatient/addPatient.vue'
export default {
  name: 'PatientInfo',
  components: {
    editPatient
  },
  data() {
    return {
      editType: 0,
      data: {},
      id: '',
      patientId: '',
      loading: false,
      setLoading: false,
      unLoading: false,
      showEdit: false
    }
  },
  created() {
    const userInfo = localStorage.getItem('userInfo')
    const { id } = JSON.parse(userInfo)
    const patientId = this.$route.query.id
    const isEdit = this.$route.query.isEdit
    this.id = id
    this.patientId = patientId
    this.showEdit = isEdit === '1'
    this.editType = isEdit * 1
    this.getPatientInfo()
  },
  mounted() {},
  methods: {
    getPatientInfo() {
      this.loading = true
      const { patientId } = this
      this.$Apis.getPatientInfo({ id: patientId }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.data = res.data
        } else {
          this.$dialog.confirm({
            title: '提示',
            message: res.message || '',
            showCancelButton: false
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    setdefault() {
      const parms = {
        id: this.id,
        patientId: this.patientId
      }
      this.$dialog.confirm({
        title: '系统消息',
        message: '是否确定设置默认就诊人？',
        confirmButtonColor: 'green'
      }).then(() => {
        this.setLoading = true
        this.$Apis.updatePatient(parms).then(res => {
          this.setLoading = false
          if (res.code === 200) {
            this.$notify({ type: 'success', message: '设置成功', duration: 500 })
            this.getPatientInfo()
          } else {
            this.$notify({ type: 'warning', message: res.message })
          }
        }).catch(() => {
          this.setLoading = false
        })
      }).catch(() => {
        // on cancel
      })
    },
    unbind() {
      const parms = {
        id: this.id,
        patientId: this.patientId
      }
      this.$dialog.confirm({
        title: '系统消息',
        message: '是否确定解除绑定？',
        confirmButtonColor: 'green'
      }).then(() => {
        this.unLoading = true
        this.$Apis.delPatient(parms).then(res => {
          this.unLoading = false
          if (res.code === 200) {
            this.$notify({ type: 'success', message: '解绑成功', duration: 500 })
            localStorage.removeItem('userInfo')
            this.$router.go(-1)
          } else {
            this.$notify({ type: 'warning', message: res.message })
          }
        }).catch(() => {
          this.unLoading = false
        })
      }).catch(() => {
        // on cancel
      })
    },
    editChange() {
      if (this.editType === 1) {
        this.$router.go(-1)
      } else {
        this.showEdit = false
        this.getPatientInfo()
      }
    },
    editBtn() {
      this.showEdit = true
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.patient-info{
  &-btn{
    display: block;
    width: 80%;
    margin: .2rem auto 0;
  }
  /deep/.van-cell__value{
    flex: 2;
  }
  .loading-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
